import PageHero from '@/components/PageHero';
import { GlassCard } from '@/components/ui/glass-card';
import { Button } from '@/components/ui/button';
import { Mail, Phone, Calendar, AlertCircle } from 'lucide-react';

const Anmeldung = () => {
  return (
    <>
      <PageHero 
        title="Anmeldung" 
        description="Melden Sie sich für die Prana Kundalini-Therapie® Ausbildung an"
        image="https://images.unsplash.com/photo-1506905925346-21bda4d32df4"
      />
      
      <section className="py-20 section-bg-white">
        <div className="container mx-auto px-4">
          {/* Important Notice */}
          <div className="max-w-4xl mx-auto mb-12">
            <GlassCard className="p-6 bg-blue-50 border-blue-200">
              <div className="flex items-start space-x-3">
                <AlertCircle className="h-6 w-6 text-blue-600 mt-1" />
                <div>
                  <h3 className="text-lg font-semibold text-blue-800 mb-2">
                    Jetzt anmelden - Begrenzte Plätze verfügbar!
                  </h3>
                  <p className="text-blue-700">
                    Sichern Sie sich Ihren Platz für die spirituelle Ausbildung. 
                    Kontaktieren Sie uns direkt für Ihre Anmeldung.
                  </p>
                </div>
              </div>
            </GlassCard>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {/* Contact Information */}
            <GlassCard className="p-8">
              <h2 className="text-2xl font-bold text-primary-deep mb-6">
                Kontakt für Anmeldung
              </h2>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <Mail className="h-6 w-6 text-primary-main mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-2">E-Mail</h3>
                    <a 
                      href="mailto:sabrina.kure@yahoo.com"
                      className="text-primary-main hover:text-primary-deep transition-colors font-medium"
                    >
                      sabrina.kure@yahoo.com
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <Phone className="h-6 w-6 text-primary-main mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-2">Telefon</h3>
                    <a 
                      href="tel:+436649703314"
                      className="text-primary-main hover:text-primary-deep transition-colors font-medium"
                    >
                      +43 664 9703314
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 space-y-4">
                <Button 
                  asChild 
                  size="lg" 
                  className="w-full bg-primary-main hover:bg-primary-deep"
                >
                  <a href="mailto:sabrina.kure@yahoo.com">
                    <Mail className="mr-2 h-5 w-5" />
                    E-Mail senden
                  </a>
                </Button>
                
                <Button 
                  asChild 
                  size="lg" 
                  variant="outline" 
                  className="w-full border-primary-main text-primary-main hover:bg-primary-main hover:text-white"
                >
                  <a href="tel:+436649703314">
                    <Phone className="mr-2 h-5 w-5" />
                    Anrufen
                  </a>
                </Button>
              </div>
            </GlassCard>

            {/* Anmeldung Information */}
            <GlassCard className="p-8">
              <h2 className="text-2xl font-bold text-primary-deep mb-6">
                Anmeldung zur Ausbildung
              </h2>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <Calendar className="h-5 w-5 text-primary-main mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Nächster Start</h4>
                    <p className="text-gray-600">Frühjahr Semester 2025 - Februar 2025</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <AlertCircle className="h-5 w-5 text-orange-500 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Begrenzte Plätze</h4>
                    <p className="text-gray-600">
                      Nur wenige Plätze verfügbar - frühzeitige Anmeldung empfohlen
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 p-4 bg-primary-lightest rounded-lg">
                <h4 className="font-semibold text-primary-deep mb-2">Was Sie erwartet:</h4>
                <ul className="text-gray-700 space-y-1">
                  <li>• 5 Module spirituelle Ausbildung</li>
                  <li>• Zertifizierte Prana Kundalini-Therapie®</li>
                  <li>• Kleine Gruppen für optimale Betreuung</li>
                  <li>• Praxis-orientierte Methoden</li>
                </ul>
              </div>
            </GlassCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default Anmeldung;